import { Component, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { VerifypatientModule, PatientPersonalInfo, getPatientDataByURl, auth } from 'src/app/models/verifypatient/verifypatient';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { IntakeMedicationService } from 'src/app/services/intake-Medication.service';
declare var $: any;
import * as LogRocket from 'logrocket';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { PaymentDeiails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from '../../services/payment.service';
import { GenericUtilityService } from '../../generic/generic-utility.service';

@Component({
  selector: 'app-verify-patient',
  templateUrl: './verify-patient.component.html',
  styleUrls: ['./verify-patient.component.css']
})
export class VerifyPatientComponent implements OnInit {
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  auth: auth;
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  maxDate: any;
  isLockScreen: boolean = false;
  currentTimeZone: any;
  selectedLanguage: any = 'en';
  selectedDay: any;
  selectedMonth: any;
  selectedYear: any;
  isCancelRescheduleEnabled: any = 0;
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  years: number[] = [];

  daysInMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  isAppointmentDetail: boolean = true;
  showThanksScreen: boolean = false;
  verifyPatientScreen: boolean = false;
  cancelScreen: boolean = false;
  rescheduleScreen: boolean = false;
  rescheduleCancel: boolean = true;
  cancelToMainScreen: boolean = false
  appStatusId: any
  landedFrom: any = "Text";
  currentLang: string = 'en';
  isRTL: boolean = false;
  isScanLicense: any = false;
  isDob: any = true;
  isAndroid: boolean = false;
  isiOS: boolean = false;
  //showCancelButton: boolean = true;
  supportMailLink: string = 'mailto:support@talkphr.com?subject=Breeze%20Check-In%20Support';
  constructor(private renderer: Renderer2, private translateService: TranslateService, private _phrutilService: PhrutillsService, private _VerifypatientService: VerifypatientService, private spinner: NgxSpinnerService, private _genericService: GenericUtilityService,
    private datepipe: DatePipe, private route: Router, private updateinfoservice: UpdateinfoService, private _route: ActivatedRoute, private medicationService: IntakeMedicationService, private service: PaymentService) {
    this.VerifypatientModule = new VerifypatientModule();
    this.PatientPersonalInfo = new PatientPersonalInfo();
    this.auth = new auth();
  }
  profileForm = new UntypedFormGroup({
    dobDay: new UntypedFormControl('', [Validators.required]),
    dobMonth: new UntypedFormControl('', [Validators.required]),
    dobyear: new UntypedFormControl('', [Validators.required])
  });


  ngOnInit(): void {
    // Platform detection
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    this.isiOS = /iPad|iPhone|iPod/.test(userAgent);
    this.isAndroid = /android/i.test(userAgent);
    let lang = localStorage.getItem('language');
    if (lang) {
      this.currentLang = lang;
      this.selectedLanguage = lang;
      if (lang == 'ur')
        this.isRTL = true;
      else
        this.isRTL = false;
    } else {
      this.isRTL = false;
      this.currentLang = 'en';
      this.selectedLanguage = 'en'
    }
    this.getCurrentTimeZone();
    this.populateYears();
    let accessLink = sessionStorage.getItem('AccessLink');
    this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this._route.queryParams.subscribe((params: Params) => {
      localStorage.clear();

      localStorage.setItem('language', this.selectedLanguage);
      if (params['testing'] != null) {
        localStorage.setItem("testing", params['testing']);
      } else {
        localStorage.removeItem("testing");

      }
      if (params['lock-screen'] != null) {
        if (accessLink) {
          //localStorage.setItem("AuthToken","");
          //$("#mainbody .modal-backdrop").removeClass("modal-backdrop");
          this.isLockScreen = true;
          // this.isLoginPage = false;
          //this.loginUserName=localStorage.getItem("userName").toString();
          this.getPatientData(accessLink);
          this.updateinfoservice.onIsShowProfilePic();
        }
        else {
          this.route.navigateByUrl('/');
        }
      }
      else {
        if (params['pa'] != null) {
          sessionStorage.setItem('AccessLink', params['pa']);
          this.getPatientData(params['pa']);
        }
        else {
          $("#linkexpire-model").modal("show");
        }
      }
      if (params['lf'] != null) {
        console.log("landed from email");
        this.landedFrom = params['lf'];

      }
      else {
        console.log("landed from text");
        this.landedFrom = "Text"
      }

    }, error => {
      localStorage.clear();
      $("#linkexpire-model").modal("show");
    });
    this.loadExternalStyles('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0');
    this._phrutilService.setTitle('Appointment Detail');
    this.buildSupportMailLink();
  }
  opentalkPHR360() {
    if (this.isAndroid) {
      console.log("open android")
      window.open('https://play.google.com/store/apps/details?id=com.carecloud.primephr', '_blank');
    } else if (this.isiOS) {
      console.log("open ios")
      window.open('https://apps.apple.com/us/app/talkphr-360-carecloud/id6746710207', '_blank');
    }
  }
  downloadtalkPHR360() {
    if (this.isAndroid) {
      console.log("download android")
      window.open('https://play.google.com/store/apps/details?id=com.carecloud.primephr', '_blank');
    } else if (this.isiOS) {
      console.log("downlaod ios")
      window.open('https://apps.apple.com/us/app/talkphr-360-carecloud/id6746710207', '_blank');
    }
  }

  fileObjFront: any;
  isFrontPhotoUpload: boolean = false;
  defaultImagefront: any;
  onChangeFileFront(event: any) {

    this.fileObjFront = event.target.files[0];
    if (this.fileObjFront) {
      this.showPreview(event, 'front');
      // this.isRequireFrontCard = false;
      event.target.value = '';
      this.OCRDrivingLicenseService();
    }
    else {
      // this.isRequireFrontCard = true;
      return;
    }
  }
  dob: any;
  isDobChecked: boolean = false;
  OCRDrivingLicenseService() {
    this._phrutilService.setChekcinType("scan");
    // console.log(this.isRequireFrontCard);
    // console.log(this.fileObjFront);
    this.spinner.show();
    this._VerifypatientService.OcrDrivingLicense(this.fileObjFront).subscribe((res: any) => {
      this.spinner.hide();
      //  console.log("ins name ",);
      // $("#Captured-Modal").modal("hide");
      //console.log("OCR Result ", res);

      if (res.iv && res && res.Data != null) {
        res.Data["License #"] = res.Data["License #"] ? this._phrutilService.decryptforDrivingLicense(res.Data["License #"], res.iv) : res.Data["License #"];
        res.Data["First Name"] = res.Data["First Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["First Name"], res.iv) : res.Data["First Name"];
        res.Data["Middle Name"] = res.Data["Middle Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Middle Name"], res.iv) : res.Data["Middle Name"];
        res.Data["Last Name"] = res.Data["Last Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Last Name"], res.iv) : res.Data["Last Name"];
        res.Data["DOB"] = res.Data["DOB"] ? this._phrutilService.decryptforDrivingLicense(res.Data["DOB"], res.iv) : res.Data["DOB"];
        res.Data["City"] = res.Data["City"] ? this._phrutilService.decryptforDrivingLicense(res.Data["City"], res.iv) : res.Data["City"];
        res.Data["State"] = res.Data["State"] ? this._phrutilService.decryptforDrivingLicense(res.Data["State"], res.iv) : res.Data["State"];
        res.Data["Zip Code"] = res.Data["Zip Code"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Zip Code"], res.iv) : res.Data["Zip Code"];
        res.Data["Issue Date"] = res.Data["Issue Date"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Issue Date"], res.iv) : res.Data["Issue Date"];
        res.Data["Expiry Date"] = res.Data["Expiry Date"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Expiry Date"], res.iv) : res.Data["License #"];
        res.Data["Gender"] = res.Data["Gender"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Gender"], res.iv) : res.Data["Gender"];
        res.Data["Class"] = res.Data["Class"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Class"], res.iv) : res.Data["Class"];
        res.Data["Address"] = res.Data["Address"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Address"], res.iv) : res.Data["Address"];
        res.Data["Complete Address"] = res.Data["Complete Address"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Complete Address"], res.iv) : res.Data["Complete Address"];


        //console.log(res.Data["DOB"]);
        if (res && res.Data["License #"] != "Null" && res.Data["License #"] != "" && res.Data["DOB"] != "Null" && res.Data["DOB"] != "") {
          this.dob = res.Data["DOB"]
          this.SubmitDobByCard();
          let data = this._phrutilService.encrypt(res);
          localStorage.setItem('licensedata', data);
        }
        else {
          //unable to scan card
          this.isDobChecked = true;
          $("#scanFail-model").modal("show");
          localStorage.removeItem('licensedata');
        }
      } else {
        //return null
        this.isDobChecked = true;
        $("#scanFail-model").modal("show");
        localStorage.removeItem('licensedata');
      }

    }, (error: any) => {
      this.spinner.hide();
      this.isDobChecked = true;
      $("#scanFail-model").modal("show");
      localStorage.removeItem('licensedata');
    })

  }

  uploadDrivingPhoto() {
    console.log("driving photo upload")
    // console.log("driving" + this.fileObjFront)
    if (this.fileObjFront) {
      // console.log("back" + this.fileObjFront)
      const subtype = "Driving License - Front"
      this._VerifypatientService.uploadAtFolder(this.fileObjFront, "api/TalkCheckin/SaveDrivingLicense_Photo", this.getPatientInfo.patientAccount, this.getPatientInfo.practiceCode, subtype).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          console.log("driving license photo uplaoded");
          this.fileObjFront = '';
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      );
    }
  }

  test() {
    console.log("volum icon press");
  }
  ChangeCheckinType(type: any) {
    if (type == 'scan') {
      this.isDob = false;
      this.isScanLicense = true;
      //this.isDobChecked = false;
    }
    else if (type == 'dob') {
      this.isDob = true;
      this.isScanLicense = false;
    }
  }

  selectLanguage(language: string) {
    this.selectedLanguage = language;
    this.currentLang = language;
    if (language == 'ur') {
      this.isRTL = true;
    } else {
      this.isRTL = false;
    }
    this.onLanguageChange();

  }
  onLanguageChange() {
    this.translateService.use(this.selectedLanguage)
    localStorage.setItem('language', this.selectedLanguage);
    // console.log("lang verify modal " + this.selectedLanguage);
    this._phrutilService.setdeafultLanguage(this.selectedLanguage);
    this._phrutilService.setPatientLanguage(this.selectedLanguage);
    this.currentLang = this.selectedLanguage;
    if (this.selectedLanguage == 'ur') {
      this.isRTL = true;
    } else {
      this.isRTL = false;
    }
    $("#language-modal").modal("hide");
    //console.log("onLanguageChange");
  }
  chnageLanguageModal() {
    $("#language-modal").modal("show");
    let lang = localStorage.getItem('language');
    if (lang) {
      // console.log("verify patient init  " + lang);
      this.currentLang = lang;
      this.selectedLanguage = lang;
      if (this.selectedLanguage == 'ur') {
        this.isRTL = true;
      } else {
        this.isRTL = false;
      }
      // console.log(this.selectedLanguage);
    }
  }

  loadExternalStyles(url: string) {
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;

    this.renderer.appendChild(document.head, link);
  }
  populateYears(): void {
    const currentYear = new Date().getFullYear();
    //const startYear = currentYear - 100;
    const startYear = 1900;
    const endYear = currentYear;

    for (let i = endYear; i >= startYear; i--) {
      this.years.push(i);
    }
  }

  updateDays(event: any) {

    const selectedDay = this.profileForm.controls['dobDay'].value;
    this.selectedMonth = parseInt(this.profileForm.controls['dobMonth'].value, 10);
    this.selectedYear = parseInt(this.profileForm.controls['dobyear'].value, 10) || new Date().getFullYear();

    if (this.selectedMonth) {
      //console.log("inside update days");
      const daysInSelectedMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      // console.log(daysInSelectedMonth);
      this.daysInMonth = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1);
      if (selectedDay != '') {
        if (selectedDay > daysInSelectedMonth) {
          this.profileForm.controls['dobDay'].setValue('');
        } else {
          this.profileForm.controls['dobDay'].setValue(selectedDay);
        }
      }

    } else {
      this.daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
    }
  }

  gotoVerify() {
    if (this.isFutureAppt2410007 == true) {
      $("#checkinNotAllowed-model").modal("show");
    } else {
      this.isAppointmentDetail = false;
      this.verifyPatientScreen = true;
      this._phrutilService.setTitle('Verify Patient');
    }
    //localStorage.setItem("updateAppointmentStatus", "false")
    //this.UpdateAppointmentstatus();
    // this.showThanksScreen = true;
    /*
     setTimeout(() => {
       this.showThanksScreen = false;
       this.verifyPatientScreen = true;
       if (this.patientLanguage == 'en') {
        // $("#language-modal").modal("show");
       }
     }, 5000);
     */

  }
  getCurrentTimeZone() {

    let currDate = new Date().toString();
    let getOffsetwithTime = currDate.split('(');
    let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
    this.currentTimeZone = offSet.trim();
    if (this.currentTimeZone.includes('+')) {
      let RemoveAlpht = this.currentTimeZone.split('+');
      this.currentTimeZone = '+' + RemoveAlpht[1];
    }
    else if (this.currentTimeZone.includes('-')) {
      let RemoveAlpht = this.currentTimeZone.split('-');
      this.currentTimeZone = '-' + RemoveAlpht[1];
    }
    console.log(this.currentTimeZone);
    localStorage.setItem("timeZone", this.currentTimeZone)
  }
  phoneLink: any;
  patientLanguage: any;
  increment: any = 0;
  appointmentid: any;
  isWithin24Hours: any;
  isWithin3Hours: any;
  isWithinRequestedHours: any;
  appointmentAddress: any;
  appointmentCity: any;
  appointmentState: any;
  appointmentZip: any;
  requestedTime: any = 18;
  dr: any = '';
  np: any = '';
  isFutureAppt2410007: boolean = false;
  getPatientData(param: any) {

    this.spinner.show();
    this._VerifypatientService.getpatientInfocheckinflow(param, this.currentTimeZone).subscribe((res: any) => {

      this.spinner.hide();
      if (res.data) {
        if (res.data.status !== 'Fail') {
          res.message == "You cannot check in before the day of your appointment - practice 2410007" ? this.isFutureAppt2410007 = true : this.isFutureAppt2410007 = false;
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          localStorage.setItem('pictureAddress', res.data.picture_Address);
          console.log("verii " + res.data.accessTokenResponse.accessToken);
          console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
          this.isCancelRescheduleEnabled = res.data.isCancelRescheduleEnabled;
          let constraint = JSON.parse(res.data.cancelRescheduleConstraint);
          if (constraint) {
            console.log("constraint ", constraint);
            this.requestedTime = constraint.time;
            console.log("requested time ", this.requestedTime);
          }
          console.log("isCancelRescheduleEnabled: ", this.isCancelRescheduleEnabled);
          //console.log(res.data);
          this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
          this.getPatientInfo.visitDate = res.data.visitDate;
          localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
          this.getPatientInfo.timE_FROM = res.data.timE_FROM;
          this.getPatientInfo.visitReason = res.data.visitReason;
          this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
          this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
          this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
          this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
          this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
          this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
          this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
          this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
          this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
          this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
          this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
          this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
          this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
          this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
          this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
          this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
          this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
          this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
          this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
          this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
          this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
          this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
          this.getPatientInfo.appointmentType = res.data.appointmentType ? this._phrutilService.decryptforServices(res.data.appointmentType) : res.data.appointmentType;
          this.getPatientInfo.appointmentLocation = res.data.appointmentLocation ? this._phrutilService.decryptforServices(res.data.appointmentLocation) : res.data.appointmentLocation;
          this.getPatientInfo.userRoleName = res.data.userRoleName ? this._phrutilService.decryptforServices(res.data.userRoleName) : res.data.userRoleName;
          this.getPatientInfo.providerTitle = res.data.providerTitle ? this._phrutilService.decryptforServices(res.data.providerTitle) : res.data.providerTitle;
          this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);
          this.appointmentAddress = this.getPatientInfo.appointmentAddress ? this.getPatientInfo.appointmentAddress : this.getPatientInfo.practiceAddress;
          this.appointmentState = this.getPatientInfo.appointmentState ? this.getPatientInfo.appointmentState : this.getPatientInfo.practiceState;
          this.appointmentCity = this.getPatientInfo.appointmentCity ? this.getPatientInfo.appointmentCity : this.getPatientInfo.PracticeCity;
          this.appointmentZip = this.getPatientInfo.appointmentZip ? this.getPatientInfo.appointmentZip : this.getPatientInfo.praticeZip;
          this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
          this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
          if (this.getPatientInfo.userRoleName === "Provider") {
            this.dr = this.getPatientInfo.practiceCode == '1013886' ? 'Mr. ' : 'Dr. ';
          } else if (this.getPatientInfo.userRoleName === "N.P/P.A") {
            this.np = ', NP';
          }
          let data = this._phrutilService.encrypt(this.getPatientInfo);
          localStorage.setItem('PatientInfoCheckin', data);
          console.log("landed from ", this.landedFrom);
          this.trackPatientPreference(this.landedFrom);
          // care-team/symptoms-checker DS dependency, currently unused - uncomment if those are reactivated
          // this.getTokenForDataScience();

          //console.log("patient details ",this.getPatientInfo);
          console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
          //this.getPatientInfo.isBreezePaymentEnabled = "1";
          console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
          console.log("appt start time ", this.getPatientInfo.timE_FROM);
          console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
          console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
          //console.log("today amount ", this.getPatientInfo.todaY_AMMOUNT);
          //const totalAmount = Number(this.getPatientInfo.todaY_AMMOUNT) + Number(this.getPatientInfo.previouS_AMMOUNT);
          //console.log("total amount ", totalAmount);
          //console.log("previous amount ", this.getPatientInfo.previouS_AMMOUNT);
          // console.log("appt duration ", this.getPatientInfo.appointmentDuration);
          //  console.log(this.getPatientInfo.practiceCode);
          //  console.log(this.getPatientInfo.reasonName);
          localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
          localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
          localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
          localStorage.setItem("reason", this.getPatientInfo.reasonName);
          localStorage.setItem("state", this.getPatientInfo.practiceState);
          localStorage.setItem("city", this.getPatientInfo.PracticeCity);
          localStorage.setItem("zip", this.getPatientInfo.praticeZip);
          localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
          localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
          localStorage.setItem("prcode", this.getPatientInfo.providerCode);
          localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
          localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
          localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
          localStorage.setItem("fname", this.getPatientInfo.firstName);
          localStorage.setItem("lname", this.getPatientInfo.lastName);
          localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);
          localStorage.setItem("apptAddr", this.appointmentAddress);
          localStorage.setItem("apptst", this.appointmentState);
          localStorage.setItem("apptcty", this.appointmentCity);
          localStorage.setItem("aptzip", this.appointmentZip);
          localStorage.setItem("aptloc", this.getPatientInfo.appointmentLocation);
          localStorage.setItem("aptType", this.getPatientInfo.appointmentType);
          localStorage.setItem("pln", this.getPatientInfo.providerLastName);
          localStorage.setItem("pfn", this.getPatientInfo.providerFirstName);
          localStorage.setItem("role", this.getPatientInfo.userRoleName);

          this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          console.log("is with in 3 hours " + this.isWithin3Hours)

          if (this.isCancelRescheduleEnabled == 1) {
            this.isWithinRequestedHours = this.checkinBeforeRequestedHours(this.requestedTime, this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            console.log("is with in " + this.requestedTime + " hours " + this.isWithinRequestedHours)
            if (this.isWithinRequestedHours) {
              this.isCancelRescheduleEnabled = 0;
            }
          }



          if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
            // console.log("using zahid function " + this.ConverttoLocalDate(this.getPatientInfo.visitDate));
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            console.log("is Same date " + this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }

          this.appointmentid = this.getPatientInfo.appointment_id;
          // localStorage.setItem("appointmentid", this.getPatientInfo.appointment_id);
          this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
          this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);
          localStorage.setItem('pracName', this.getPatientInfo.practiceName);
          console.log(this.getPatientInfo.languages + "language");
          if (this.getPatientInfo.practiceCode == '2410007' || this.getPatientInfo.practiceCode == '1013886') {
            this.patientLanguage = 'en';
            localStorage.setItem('language', this.patientLanguage);
            this.selectedLanguage = this.patientLanguage;
            this.translateService.use(this.selectedLanguage)
            this._phrutilService.setdeafultLanguage(this.selectedLanguage);
            this._phrutilService.setPatientLanguage(this.selectedLanguage);
            this.currentLang = this.selectedLanguage;
          }
          else {
            if (this.getPatientInfo.languages == 'Spanish') {
              this.patientLanguage = 'es';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
              console.log(this.selectedLanguage);
            } else if (this.getPatientInfo.languages == 'Hindi') {
              this.patientLanguage = 'hi';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              console.log(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
            } else if (this.getPatientInfo.languages == 'Urdu') {
              this.patientLanguage = 'ur';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              console.log(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
            } else {
              this.patientLanguage = 'en';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              $("#language-modal").modal("show");
              this.currentLang = this.selectedLanguage;
            }

          }


          if (this.getPatientInfo.practicePhone) {
            this.phoneLink = "tel:+1" + this.getPatientInfo.practicePhone;
            this.getPatientInfo.practicePhone = this._phrutilService.maskingPhoneNumer(this.getPatientInfo.practicePhone);
          }

          // Log Rocket Implementation
          const LogRocket = require('logrocket/setup')({
            sdkServer: 'https://logrocket.carecloud.com',
            ingestServer: 'https://logrocket.carecloud.com'
          });
          LogRocket.init('carecloud/breeze-checkin');
          LogRocket.startNewSession();
          LogRocket.identify(this.getPatientInfo.patientAccount, {
            name: this.getPatientInfo.patientAccount,
            email: this.getPatientInfo.emailAddress,
            // Add your own custom user variables here, ie:
            subscriptionType: 'pro'
          });
          if (this.getPatientInfo.appointmentStatusId == '3' && this.currentLang != null && this.cancelToMainScreen == false && this.isCancelRescheduleEnabled == '1') {
            this.rescheduleCancel = false;
            $("#language-modal").modal("hide");
            $("#CancelrescheduleModal").modal("show");
          }
          //console.log('record ', this.getPatientInfo);
          /*
          if (this.getPatientInfo.appointmentStatusId == '15') {
            console.log("inside appointment start");
            localStorage.setItem("checkin", 'true')
            localStorage.setItem("alredycheckin", 'true');
            localStorage.setItem("noIntakeForm", "true");
            this.route.navigateByUrl('patient/thank-you');
            console.log("inside appointment end");
           
          }*/
          // this.auth.USER_NAME = "breezecheckin";
          // this.auth.PWD = "tci@1234";

          // this._VerifypatientService.Authentication(this.auth).subscribe((res:any) =>{

          //   localStorage.setItem("AuthToken",res.RESPONSE.token);
          // })

          /*
          try {

            let token = localStorage.getItem("AuthTokenwebServices")
            if (!token || token == '' || token == undefined || token==null || token=='null') {
              console.log("--Start We are getting AuthTokenwebServices " + token + " that's why we are getting patient data again --Start");
              const accessLink = sessionStorage.getItem('AccessLink');
              if (this.increment < 3) {
                this.getPatientData(accessLink);
                console.log("--END We are getting AuthTokenwebServices " + token + " that's why we are getting patient data again --END");
              }
              this.increment = this.increment + 1;
            }
          } catch (error) {
            this.increment = 4;
          } */

        }
        else {
          // this.getPatientAppointmentData(param);
          $("#linkexpire-model").modal("show");
          return;
        }

      }
      else {
        $("#linkexpire-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    });
  }

  getTokenForDataScience() {
    try {
      if (localStorage.getItem('AuthToken')) return;
      this._genericService.getTokenForDataScience().subscribe({
        next: (res: any) => {
          try {
            if (res?.RESPONSE?.token) {
              localStorage.setItem('AuthToken', res.RESPONSE.token);
            }
          } catch (err) {
            console.error('Error storing AuthToken:', err);
          }
        },
        error: (err) => {
          console.error('Error fetching token for data science:', err);
        }
      });
    } catch (err) {
      console.error('Error in getTokenForDataScience:', err);
    }
  }


  // past day appointment check
  getPatientAppointmentData(param: any) {

    this.spinner.show();
    this._VerifypatientService.getpatientAppointmentInfo(param, this.currentTimeZone).subscribe((res: any) => {
      this.spinner.hide();
      console.log(res);
      this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
      this.getPatientInfo.visitDate = res.data.visitDate;
      this.getPatientInfo.timE_FROM = res.data.timE_FROM;
      this.getPatientInfo.visitReason = res.data.visitReason;
      this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
      this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
      this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
      this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
      this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
      this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
      this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
      this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
      this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
      this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
      this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
      this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
      this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
      this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
      this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
      this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
      this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
      this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
      this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
      this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
      this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
      this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
      this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
      this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
      this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
      this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;


      this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
      this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
      this.isPreviousdatAppointmetn = this.checkAppointmentDate(this.getPatientInfo.visitDate)
      console.log("past appointment", this.isPreviousdatAppointmetn);
      if (this.isPreviousdatAppointmetn) {
        $("#PreviousDayAppointment_model").modal("show");
        return;
      } else {
        $("#linkexpire-model").modal("show");
        return;
      }


    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    })
  }
  isPreviousdatAppointmetn: any
  checkAppointmentDate(visitDate: any) {
    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);

    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    if ((visitDateTime.trim() < currentDateTime.trim())) {
      return true;
    } else {
      return false;
    }
  }
  ObjAction: any = {};
  trackPatientPreference(lf: any) {
    // console.log("landed from ", lf);
    this.ObjAction['patientAccount'] = this.getPatientInfo.patientAccount;
    this.ObjAction['practiceCode'] = this.getPatientInfo.practiceCode;
    this.ObjAction['appointmentID'] = this.getPatientInfo.appointment_id;
    this.ObjAction['action'] = lf;
    this.ObjAction['createdBy'] = this.getPatientInfo.firstName + " " + this.getPatientInfo.lastName;
    this.ObjAction['appSource'] = "breezeCheckin";
    //console.log("action object ", this.ObjAction);
    this._VerifypatientService.ManageActionItems(this.ObjAction).subscribe((res: any) => {
      //console.log(res);
    }, (error: any) => {
      console.log(error);
    })

  }
  ConfirmCancelAppointment() {
    $("#confirmCancelModal").modal("show");
  }
  ConfirmRescheduleAppointment() {
    $("#confirmRescheduleModal").modal("show");
  }
  gotoCancelAppointmentScreen() {
    this.isAppointmentDetail = false;
    this.cancelScreen = true;
    this.verifyPatientScreen = false;
    this.rescheduleScreen = false;
    // $("#rescheduleModal").modal("show");
    this._phrutilService.setTitle('Verify Patient');
  }
  gotoRescheduleScreen() {
    this.isAppointmentDetail = false;
    this.cancelScreen = false;
    this.verifyPatientScreen = false;
    this.rescheduleScreen = true;
    this._phrutilService.setTitle('Verify Patient');

  }
  rescheduleAppointment() {
    if (this.getPatientInfo.appointmentStatusId == '3') {
      localStorage.setItem("landFrom", "checkin_cancel");
      this.route.navigateByUrl("/exitingappointment");
    }
    else {
      // this.route.navigateByUrl("/home?practice_code=" + '1011163');
      const queryParams = {
        provider: this.getPatientInfo.providerCode,
        reason: this.getPatientInfo.reason_Id,
        location: this.getPatientInfo.appointmentLocation,
        appointmenttype: this.getPatientInfo.appointmentType,
        timeZone: this.currentTimeZone,
        apptdate: this.getPatientInfo.visitDate
      };
      localStorage.setItem("landFrom", "checkin_reschedule");
      console.log('Navigating with Query Params:', queryParams);

      this.route.navigate(['/exitingappointment'], { queryParams });
    }
  }
  rescheduleAfterCancel() {
    localStorage.setItem("landFrom", "checkin_cancel");
    if (this.getPatientInfo.appointmentStatusId == '3') {
      //console.log("inside reschedule after cancel");
      this.isAppointmentDetail = false;
      this.verifyPatientScreen = false;
      this.rescheduleScreen = true;
      this._phrutilService.setTitle('Verify Patient');
    }
    else {
      this.route.navigateByUrl("/exitingappointment");
    }
  }
  cancelAppointment() {
    const cancelObj = {
      appointment_Id: this.getPatientInfo.appointment_id,
      is_canceled: true,
      patient_Account: this.getPatientInfo.patientAccount,
      teleMedicine_Session: this.getPatientInfo.appointmentType == 'teleHealth' ? true : false,
    }
    this._VerifypatientService.cancelAppointment(cancelObj).subscribe((res: any) => {
      if (res && res.data.isAppointmentCanceled == "SUCCESS") {
        $("#rescheduleModal").modal("show");
      }

    }, (error: any) => {
      console.log(error);
      let text = "Service is not available, please try later.";
      $("#linkexpire-model").modal("show");
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
    })
  }
  redirectToHome() {
    this.route.navigateByUrl("/home?practice_code=" + this.getPatientInfo.practiceCode);
  }

  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);


    // const currentDateFormatted = this.getCurrentDateFormatted();
    // console.log("current date with format " + currentDateFormatted)



    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    // Add one day to today's date
    const nextDay = this.ConverttoLocalDateInDay(new Date());
    nextDay.setDate(nextDay.getDate() + 1);



    const nextDaydate = this.ConverttoLocalDate(nextDay);
    console.log("next day date " + nextDaydate);
    //console.log("current date time " + typeof currentDateTime);

    if ((visitDateTime.trim() === currentDateTime.trim()) || (visitDateTime.trim() === nextDaydate.trim())) {
      return true;
    } else {
      return false;
    }
  }

  checkinBeforeRequestedHours(requestedTime: any, visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;
      console.log("visit date time string ", visitDateTimeStr)
      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log(requestedTime, " hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log(requestedTime, " hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log(requestedTime, " hour difference: " + diffInHours);

      // Check if the difference is within requested hours
      return diffInHours <= requestedTime || diffInHours < 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }



  AppointmentStatusConfirmed: any;
  UpdateAppointmentstatus() {
    //tM2hXGTAFn9xY21Pd7JGYg==
    // this.appointmentid;
    this.AppointmentStatusConfirmed = 2;
    this._VerifypatientService.ConfirmAppointment(this.appointmentid, this.AppointmentStatusConfirmed).subscribe((res: any) => {
      console.log(res)
      if (res.message == "Record Updated") {
        localStorage.setItem("updateAppointmentStatus", "true")
      } else {
        localStorage.setItem("updateAppointmentStatus", "false")
      }


    })
  }
  SubmitDobByCard() {
    if (this.getPatientInfo.practiceCode) {
      this.spinner.show();

      this.VerifypatientModule.DOB = this.dob;
      this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();

      this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;

      this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;

      this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
      this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {

        this.spinner.hide();
       // if (res.RESPONSE[0]) {

         // this.PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
        if (res.Data) {
          this.PatientPersonalInfo = res.Data as PatientPersonalInfo;
          this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
          this.PatientPersonalInfo.isShowpicture = true;
          this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
          this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
          let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

          console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
          localStorage.setItem('PersonalInfo', data);
          //localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
          localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
          localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
          this.uploadDrivingPhoto();
          this.updateinfoservice.onIsShowProfilePic();
          this._VerifypatientService.startRefreshTokenTimer();
          this._phrutilService.setChekcinType("dob");
          if (this.isLockScreen) {
            localStorage.setItem("lockscreen", "true");
            this.route.navigateByUrl('/patient/consent-form');
          }
          else
            this.route.navigateByUrl('/patient/consent-form');


        } else {
          this.isDobChecked = true;
          $("#incorrectinfoLicense-model").modal("show");
        }
      }, (error: any) => {
        this.isDobChecked = true;
        $("#incorrectinfoLicense-model").modal("show");
        this.spinner.hide();
      })

    } else {
      let text = "Service is not available, please try later.";
      $("#linkexpire-model").modal("show");
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
    }

  }

  onSubmit(callFrom: string) {
    if (this.isScanLicense && !this.isDob) {
      if (this.fileObjFront) {
        this.OCRDrivingLicenseService();
      } else {
        $("#cardMissing-model").modal("show");
      }

      return;
    }
    this._phrutilService.setChekcinType("dob");
    if (this.getPatientInfo.practiceCode) {
      if (this.profileForm.valid) {
        this.spinner.show();

        const dobDay = this.profileForm.controls['dobDay'].value;
        const dobMonth = this.profileForm.controls['dobMonth'].value;

        const dobYear = this.profileForm.controls['dobyear'].value;

        // const paddedDobDay = dobDay.toString().padStart(2, '0');
        // const paddedDobMonth = dobMonth.toString().padStart(2, '0');
        // var dateOfBirth = dobYear + "-" + paddedDobMonth + "-" + paddedDobDay;
        // var dobDate = new Date(dateOfBirth);
        const formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
        //const formattedDate = this.datepipe.transform(dobDate, 'MM/dd/yyyy');

        this.VerifypatientModule.DOB = formattedDate;
        this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();
        //this.VerifypatientModule.PRACTICE_CODE = '1011163';
        //this.VerifypatientModule.LAST_NAME = this.profileForm.controls['lastName'].value.trim();
        this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;
        // this.VerifypatientModule.FIRST_NAME = this.profileForm.controls['firstName'].value.trim();
        this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;
        // this.VerifypatientModule.DOB = this.datepipe.transform(this.profileForm.controls['dob'].value, 'MM/dd/yyyy');
        this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
        this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {
          //this._VerifypatientService.VerifyPatient(this.VerifypatientModule).subscribe((res: any) => {

          this.spinner.hide();
          if (res.Data) {

            this.PatientPersonalInfo = res.Data as PatientPersonalInfo;
            this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
            this.PatientPersonalInfo.isShowpicture = true;
            this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
            this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
            let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

            console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
            localStorage.setItem('PersonalInfo', data);
            //localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
            localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
            localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)

            this.updateinfoservice.onIsShowProfilePic();
            this._VerifypatientService.startRefreshTokenTimer();

            // Log Rocket Implementation
            /*const LogRocket = require('logrocket/setup')({
              sdkServer: 'https://logrocket.carecloud.com',
              ingestServer: 'https://logrocket.carecloud.com'
            });
            LogRocket.init('carecloud/breeze-checkin');
            LogRocket.startNewSession();
            LogRocket.identify(localStorage.getItem('patientAccount'), {
              name: localStorage.getItem('patientAccount'),
              email: localStorage.getItem('userName'),
              // Add your own custom user variables here, ie:
              subscriptionType: 'pro'
            });*/
            /*
            if (this.getPatientInfo.appointmentStatusId == '15') {
           
              console.log("inside appointment start");
              localStorage.setItem("checkin", 'true')
              localStorage.setItem("alredycheckin", 'true');
              console.log("inside appointment end");
              this.getPaymentDetails();

            }*/
            if (this.isLockScreen) {
              // let visitURL = sessionStorage.getItem("VisitedURL");
              // this.route.navigateByUrl(visitURL?visitURL:'/');
              //check if the session is from lock screen the redirect on consent form and check the last visited URL
              localStorage.setItem("lockscreen", "true");
              this.route.navigateByUrl('/patient/consent-form');
            }
            else {
              if (callFrom == "cancel") {
                console.log("cancel appointment");
                this.cancelAppointment();
              } else if (callFrom == "reschedule") {
                console.log("reschedule appointment");
                this.rescheduleAppointment();
              } else {
                this.route.navigateByUrl('/patient/consent-form');
              }


            }



          } else {
            $("#incorrectinfo-model").modal("show");
          }
        }, (error: any) => {
          $("#incorrectinfo-model").modal("show");
          this.spinner.hide();
        })
      } else {
        this.profileForm.markAllAsTouched();
      }
    } else {
      let text = "Service is not available, please try later.";
      $("#linkexpire-model").modal("show");
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
    }

  }
  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();
      this.profileForm.controls[type].setValue(event.value);
    }
  }

  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }


  ConverttoLocalDate(date: any): string {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      // date = new Date(date);
    }

    return date;
  }

  ConverttoLocalDateInDay(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      date = new Date(date);
    }

    return date;
  }

  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss A');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }


  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetails(this.getPatientInfo.practiceCode, this.getPatientInfo.patientAccount, this.getPatientInfo.appointment_id).subscribe((res: any) => {
      this.spinner.hide();
      //   { "statusCode": 200, "message": "SUCCESS","data": { "amT_DUE": "492.90", "currentDayAmount": "0.00",
      //         "totalAmount": "492.90",
      //         "prI_SEC_OTH_TYPE": "P", "id": "1", "inspayeR_DESCRIPTION": "MEDICARE ADVANTAGE", "visit_Date": "",
      //         "visit_Reasons": ""  } }
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        if (this.paymentDetials.data.totalAmount != null && this.paymentDetials.data.totalAmount != "") {
          if (Number(this.paymentDetials.data.totalAmount) <= 0 && this.getPatientInfo.appointmentStatusId == "15") {
            localStorage.setItem("noIntakeForm", "true");
            this.route.navigateByUrl('patient/thank-you');
          } else {
            this.route.navigateByUrl('patient/payment-overview');
          }
        }

        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();


      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      //this._phrutilService.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  //show local image
  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);
        fileReader.addEventListener('load', (event) => {
          console.log("front");
          this.isFrontPhotoUpload = true;
          this.defaultImagefront = event.target?.result;

        })
      }
    }
  }
  gotoHome() {
    this.verifyPatientScreen = false;
    this.isAppointmentDetail = true;
    const query = sessionStorage.getItem('AccessLink');
    this.getPatientData(query);
    this._phrutilService.setTitle('Appointment Detail');
    this.rescheduleCancel = false;
    this.cancelToMainScreen = true;
  }
  buildSupportMailLink() {
    const accountNumber = localStorage.getItem('accountNumber') || '';  // <-- yahan apni actual key daalein

    const subject = `Breeze Check-In Support - ${accountNumber}`;
    this.supportMailLink = `mailto:support@talkphr.com?subject=${encodeURIComponent(subject)}`;
  }
}
